import "../static/Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaEnvelope
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">

      {/* Glow Background */}
      <div className="footer-glow glow1"></div>
      <div className="footer-glow glow2"></div>

      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-section">
          <h2 className="footer-logo">QAura Tech Solutions</h2>
          <p>
            QAura Tech Solutions empowers students, startups, and enterprises
            with cutting-edge web development, AI solutions, branding, and
            career-focused digital services.
          </p>

          <div className="social-icons">
            <a href="/"><FaFacebookF /></a>
            <a href="https://www.instagram.com/qauratechsolutions?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/quaratech-solutions" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.youtube.com/@QAuraTechSolutions"><FaYoutube /></a>
            <a href="https://wa.me/916281485302" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a><a href="mailto:qauratechsolutions@gmail.com"><FaEnvelope /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li><a href="/">Web & App Development</a></li>
            <li><a href="/">AI Solutions</a></li>
            <li><a href="/">E-Commerce Platforms</a></li>
            <li><a href="/">Branding & UI/UX Design</a></li>
            <li><a href="/">Interview Preparation</a></li>
          </ul>
        </div>

        {/* Legal & Policies */}
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><a href="/terms">Terms & Conditions</a></li>
            <li><a href="/policy">Privacy Policy</a></li>
            <li><a href="/refund">Refund Policy</a></li>
            <li><a href="/cancel">Cancellation Policy</a></li>
            <li><a href="/declaimer">Disclaimer</a></li>
            <li><a href="/cookies">Cookie Policy</a></li>
          </ul>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} QAura Tech Solutions. All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;
